/* Package JSON Import will be here */
import React from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Card, Typography, Space, Spin, Divider } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import { selectWholesaler } from "reducers/wholesalers";
import fssaiNumberLogo from "assets/img/fssai-logo.png";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { confirm } = Modal;
const { Text } = Typography;
/* Const,Let & Var will be here */

const SelectWholeSalerModal = (props) => {
    const dispatch = useDispatch();

    const { translate, wholesalers } = useSelector((state) => ({
        translate: getTranslate(state.locale),
        wholesalers: state.wholesalers,
    }));

    const selectDistributor = (item) => {
        /* Ask confirmation to make selected distributor as default distributor */
        confirm({
            title: translate("wholesaler.switch.switchConfirmation"),
            centered: true,
            okText: translate("common.buttons.ok"),
            cancelText: translate("common.buttons.cancel"),
            onOk: () => {
                dispatch(selectWholesaler(item, true));
            }
        });
    }

    return (
        <React.Fragment>
            <Modal
                title={translate("wholesaler.selectedDistributor")}
                width={500}
                centered
                maskClosable={true}
                closable={false}
                footer={null}
                visible={props.isShowDistributorSelectionModal}
                className="select-dist-modal"
            >
                <Spin
                    tip={translate("wholesaler.switch.loading")}
                    spinning={wholesalers.isLoadingSwitchDist}
                >
                    {wholesalers.data.map(item => (
                        <Card
                            key={item.dId}
                            size="small"
                            className="ant-card-with-box-shadow w-100 border-radius-15 mb-2"
                            onClick={() => selectDistributor(item)}
                        >
                            <h6>{item.dName}</h6>

                            <div className="whole-seller-address">
                                <p className="whole-seller__description responsive-font-size pad--l--0 mt-2">
                                    {item.address}
                                </p>
                            </div>

                            {/* Distributor Fssai Number section */}
                            {(item.fssaiNo !== undefined && item.fssaiNo !== null) &&
                                <div className="p-2">
                                    <Space>
                                        <img className="pb-1" src={fssaiNumberLogo} alt="" />
                                        <Text strong>{item.fssaiNo}</Text>
                                    </Space>
                                </div>
                            }
                        </Card>
                    ))}

                    <div className="p-2">
                        <Divider />
                    </div>

                    <Text type="warning" className="font-12">{translate("wholesaler.switch.note")}</Text>
                </Spin>
            </Modal>
        </React.Fragment>
    );
};

export default SelectWholeSalerModal;